(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/views/contact.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/views/contact.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service.views.Contact = Backbone.Marionette.View.extend({
    tagName: 'div',
    id: 'contact',

    template: function(data) {
      return svs.customer_service.templates.contact(data);
    },
    events: {
      'submit #contactCustomerService': 'postQuestionToCustomerService',
      'click .js-login': 'login',
      'change #subject': 'setGreenSubmitButton',
      'click .js-customer-service-nav': 'navigate',
      'click .js-open-chat': 'onChatClick',
      'blur textarea': 'storeQuestion'
    },
    modelEvents: {
      change: 'render'
    },

    initialize: function() {
      svs.customer_service_logger.debug('svs.customer_service.views.Contact - initialize');
    },

    login: function(e) {
      e.preventDefault();
      svs.components.customer_login.login();
    },
    storeQuestion: function() {
      this.model.set({ customerServiceQuestion: $('textarea').val() }, { silent: true });
    },
    postQuestionToCustomerService: function(event) {
      event.preventDefault();
      var fields = ['email', 'subject', 'message'],
        isValidClientSide = Math.min(svs.components.formValidation.validateFields(fields), svs.components.formValidation.validateRequiredFields(fields)),
        loader = svs.components.Loader();

      if (isValidClientSide) {
        svs.components.formValidation.hideErrorMessage('personalId');
        loader.show();
        this.model.postQuestionToCustomerService(
          svs.customer_service.utils.getFormData('contactCustomerService'),
          function() {
            loader.hide();
            document.getElementById('contactCustomerService').reset();
            var _dialog = new svs.components.dialog.Confirm({
              icon: 'nav-my-bets',
              branding: svs.components.dialog.branding.TUR,
              area: svs.components.dialog.area.TOASTER,
              title: 'Din fråga är skickad. Du kommer att få svar till din e-post inom kort.',
              actions: [
                {
                  title: 'OK'
                }
              ]
            });
            svs.components.dialog.api.add(_dialog);
          },
          function(err) {
            loader.hide();
            svs.customer_service_logger.info('Error response in post question to KS', svs.core.jupiter.parseErrorResponse(err));
            svs.customer_service.utils.showErrorMessage(err);
          }
        );
      } else {
        svs.customer_service_logger.debug('isValidClientSide = ' + isValidClientSide);
      }
    },
    navigate: function(e) {
      var elem = e.currentTarget;
      var page = /.*\/(.*)/; 
      svs.customer_service.router.navigate(page.exec($(elem).attr('href'))[1], { trigger: true });
      return false;
    },
    onChatClick: function(evt) {
      if (svs.components && svs.components.chat) {
        svs.components.chat.open();
      }
      evt.preventDefault();
    }
  });
})(Backbone, _, svs);

 })(window);